import { emailRequired, lastNameRequired } from '@lib/yup'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  firstName: Yup.string(),
  lastName: lastNameRequired,
  email: emailRequired,
  agree: Yup.bool().oneOf([true]),
})
